<template>
  <CreateGift class="create-gift" />
</template>
<script>
import CreateGift from './CreateGift'
export default {
  components: { CreateGift }
}
</script>
<style lang="scss" scoped>
.create-gift {
  & /deep/ path {
    fill: $white;
  }
}
</style>
